export default {
    deleteRoles: ['admin'],
}
